export default {
    deleteRoles: ['admin'],
}
